<div [class.loader-hidden]="!show">
  <div *ngIf="show" class="isSubmitting loader-overlay"></div>
  <mat-progress-bar
    *ngIf="show"
    class="isSubmitting"
    mode="indeterminate"
  ></mat-progress-bar>
</div>
